// const list1 = [{
//     id: 1,
//     className: 'flex-1',
//     name: '体检',
//     label: 2398
// }, {
//     id: 2,
//     className: 'flex-1',
//     name: '降血脂',
//     label: 3784
// }, {
//     id: 3,
//     className: 'flex-1',
//     name: '降血糖',
//     label: 98341
// }];
const list3 = [ {
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
}];

// 宿迁（1127）专用列表
const listSuQian = [{
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
}, {
    id: 20,
    className: 'flex-1',
    name: '基因溯源鉴安版',
    label: 2999,
    tag: ''
}, {
    id: 5,
    className: 'flex-1',
    name: '基因溯源探索版',
    label: 5999,
    tag: ''
}];

const list3FoShan = [{
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
}];
const listGuoShou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
}];
// 瑞众广东省公司（1423）专用列表：基因溯源5999，华大壹号仅地区3为8999，其他地区7999
const list1423 = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
}];
const list1423Area3 = list1423.map(item => ({
    ...item,
    label: item.id === 6 ? 8999 : item.label,
}));
// 南通专用列表：在国寿基础上增加“华大壹号PLUS”
const listNanTong = [
    ...listGuoShou,
    {
        id: 11,
        className: 'flex-1',
        name: '华大壹号PLUS',
        label: 12000,
        tag: ''
    }
];

// 泰安（1422）专用列表：基因溯源、黄金壹号、黄金壹号PLUS、心脑卫士
const list1422 = [
    ...listGuoShou.filter(item => item.id === 5),
    {
        id: 6,
        className: 'flex-1',
        name: '黄金壹号',
        label: 7999,
        tag: ''
    },
    {
        id: 11,
        className: 'flex-1',
        name: '黄金壹号PLUS',
        label: 12000,
        tag: ''
    },
    {
        id: 17,
        className: 'flex-1',
        name: '心脑卫士',
        label: 7999,
        tag: ''
    }
];

// 淄博（1092，由原1420转移）专用列表：在默认产品基础上增加华大壹号PLUS、细胞存储10年期和20年期
const list1092 = [
    ...listGuoShou,
    {
        id: 11,
        className: 'flex-1',
        name: '华大壹号PLUS',
        label: 12000,
        tag: ''
    },
    {
        id: 21,
        className: 'flex-1',
        name: '细胞存储10年期',
        label: 9000,
        tag: ''
    },
    {
        id: 22,
        className: 'flex-1',
        name: '细胞存储20年期',
        label: 12800,
        tag: ''
    }
];

// 烟台（1184）专用列表：只保留基因溯源和华大壹号PLUS
const listYanTai1184 = listNanTong.filter(item => item.id === 5 || item.id === 11);

const listNanTongZhuMa = [
    ...listGuoShou,
    {
        id: 11,
        className: 'flex-1',
        name: '华大壹号PLUS',
        label: 12000,
        tag: ''
    },{
        id: 17,
        className: 'flex-1',
        name: '心脑卫士',
        label: 7999,
        tag: ''
    }
];




// 南通银保（1205）专用列表：在国寿基础上增加“华大壹号PLUS”
const listNanTongYinBao = [
    ...listGuoShou,
    {
        id: 11,
        className: 'flex-1',
        name: '华大壹号PLUS',
        label: 12000,
        tag: ''
    }
];
// 驻马店（1295）专用列表：在南通基础上增加「IPSC时光胶囊」（仅 areaCode 1、2 使用）
const listZhuMaDian = [
    ...listNanTong,
    {
        id: 13,
        className: 'flex-1',
        name: 'IPSC时光胶囊',
        label: 12800,
        tag: ''
    },
    {
        id: 17,
        className: 'flex-1',
        name: '心脑卫士',
        label: 7999,
        tag: ''
    }
];
// 长春市（1204）专用列表：基因溯源+华大壹号PLUS+细胞存储
const listChangChun = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 11,
    className: 'flex-1',
    name: '华大壹号PLUS',
    label: 12000,
    tag: ''
}, {
    id: 19,
    className: 'flex-1',
    name: '细胞存储',
    label: 12800,
    tag: ''
}];
// 平潭（1182）专用列表：保留国寿两个项目，追加“细胞存储”
const listPingTan = [
    ...listGuoShou,
    {
        id: 8,
        className: 'flex-1',
        name: '细胞存储',
        label: 12000,
        tag: ''
    }
];
const listYangZhou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 8199,
    tag: ''
}];

const listTaiZhou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 6199,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 8199,
    tag: ''
}];

const listSuZhou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
},{
        id: 17,
        className: 'flex-1',
        name: '心脑卫士',
        label: 7999,
        tag: ''
    }];

const listSuZhouShenZhen = [
    ...listSuZhou,
    {
        id: 18,
        className: 'flex-1',
        name: '细胞存储（定制版）',
        label: 3999,
        tag: ''
    }
];

// 苏州吴中（1402）专用列表：在默认产品基础上增加细胞存储和心脑卫士
const listSuZhouWuZhong = [
    ...list3,
    {
        id: 18,
        className: 'flex-1',
        name: '细胞存储',
        label: 3999,
        tag: ''
    },
    {
        id: 17,
        className: 'flex-1',
        name: '心脑卫士',
        label: 7999,
        tag: ''
    }
];

// 机构 987 专用列表：在默认产品基础上增加细胞存储
const listOrg987 = [
    ...list3,
    {
        id: 18,
        className: 'flex-1',
        name: '细胞存储',
        label: 3999,
        tag: ''
    }
];

// 机构 1284 专用列表：在默认产品基础上增加心脑卫士
const listOrg1284 = [
    ...list3,
    {
        id: 30,
        className: 'flex-1',
        name: '心脑卫士',
        label: 8999,
        tag: ''
    }
];

// 机构 1284 区域 3 专用价格：华大壹号调整为 8999
const listOrg1284Area3 = listOrg1284.map(item => ({
    ...item,
    label: item.id === 6 ? 8999 : item.label,
}));


const listTianJin = [
    {
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
},{
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
},{
        id: 17,
        className: 'flex-1',
        name: '心脑卫士',
        label: 7999,
        tag: ''
    }
];

// 天津（1113）区域 1 专用列表：隐藏心脑卫士
const listTianJinArea1 = listTianJin.filter(item => item.id !== 17);

const listChangZhou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 7000,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 10000,
    tag: ''
}];

const listGuoShouZhuZhou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 8999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 12999,
    tag: ''
}, {
    id: 7,
    className: 'flex-1',
    name: '外泌体雾化6支',
    label: 4580,
    tag: ''
}, {
    id: 8,
    className: 'flex-1',
    name: '细胞存储',
    label: 16999,
    tag: ''
}];
// 湘潭（1189）专用列表：基因溯源、华大壹号、细胞存储
const listXiangTan = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 6800,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 9500,
    tag: ''
}, {
    id: 8,
    className: 'flex-1',
    name: '细胞存储',
    label: 14800,
    tag: ''
}];
// 株洲（1190）专用列表：基因溯源、华大壹号、细胞存储
const listZhuZhou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 7199,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 10399,
    tag: ''
}, {
    id: 8,
    className: 'flex-1',
    name: '细胞存储',
    label: 13599,
    tag: ''
}];
// 吉林市（1203）专用列表：保留基因溯源+华大壹号，追加细胞存储
const listJiLin = [
    ...listGuoShou,
    {
        id: 8,
        className: 'flex-1',
        name: '细胞存储',
        label: 9999,
        tag: ''
    }
];
const zhengzhou = [{
    id: 1,
    className: 'flex-1',
    name: '雾化套装',
    label: 3800,
    tag: ''
}, {
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
}];
// 1113
const list1 = [{
    id: 3,
    className: 'flex-1',
    name: '外泌体回输',
    label: 7999,
    tag: ''
},{
    id: 4,
    className: 'flex-1',
    name: '定制化免疫细胞存储',
    label: 7999,
    tag: ''
}];
//1211
const shaoyang = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 6800,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 9800,
    tag: ''
}];
//1234
const zhoukou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
},{
    id: 11,
    className: 'flex-1',
    name: '华大壹号PLUS',
    label: 12000,
    tag: ''
},
    {
        id: 13,
        className: 'flex-1',
        name: 'IPSC时光胶囊',
        label: 9999,
        tag: ''
    }];
//1244
const list1244Config = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 9000,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 11000,
    tag: ''
}];
//1245
const list1245Config = [
    ...listGuoShou,
    {
        id: 11,
        className: 'flex-1',
        name: '华大壹号PLUS',
        label: 12000,
        tag: ''
    }
];
// const list2 = [{
//     id: 7,
//     className: 'flex-1',
//     name: '降血压',
//     label: 3948
// }, {
//     id: 8,
//     className: 'flex-1',
//     name: '消化系统',
//     label: 98341
// }, {
//     id: 9,
//     className: 'flex-1',
//     name: '心脏彩超',
//     label: 3948
// }];
export const list = [list3];
export const expendList = [...list3];
export const suQianList = [listSuQian];
export const expendSuQianList = [...listSuQian];
export const foShanList = [list3FoShan];
export const expendFoShanList = [...list3FoShan];

export const guoShouList = [listGuoShou];
export const expendGuoShouList = [...listGuoShou];
export const list1423List = [list1423];
export const expendList1423 = [...list1423];
export const list1423Area3List = [list1423Area3];
export const expendList1423Area3 = [...list1423Area3];
export const nanTongList = [listNanTong];
export const expendNanTongList = [...listNanTong];
export const list1422List = [list1422];
export const expendList1422 = [...list1422];
export const list1092List = [list1092];
export const expendList1092 = [...list1092];
export const yanTai1184List = [listYanTai1184];
export const expendYanTai1184List = [...listYanTai1184];


export const nanTongYinBaoList = [listNanTongYinBao];
export const expendNanTongYinBaoList = [...listNanTongYinBao];
export const zhuMaDianList = [listZhuMaDian];
export const expendZhuMaDianList = [...listZhuMaDian];
export const changChunList = [listChangChun];
export const expendChangChunList = [...listChangChun];
export const pingTanList = [listPingTan];
export const expendPingTanList = [...listPingTan];
export const guoShouZhuZhouList = [listGuoShouZhuZhou];
export const expendGuoShouZhuZhouList = [...listGuoShouZhuZhou];
export const xiangTanList = [listXiangTan];
export const expendXiangTanList = [...listXiangTan];
export const zhuZhouList = [listZhuZhou];
export const expendZhuZhouList = [...listZhuZhou];
export const jiLinList = [listJiLin];
export const expendJiLinList = [...listJiLin];

// 1405 专用列表：在默认产品基础上增加「IPSC时光胶囊」
const list1405 = [
    ...list3,
    {
        id: 21,
        className: 'flex-1',
        name: 'IPSC时光胶囊10年',
        label: 9000,
        tag: ''
    },{
        id: 22,
        className: 'flex-1',
        name: 'IPSC时光胶囊20年',
        label: 12800,
        tag: ''
    }
];
export const list1405List = [list1405];
export const expendList1405 = [...list1405];

// 1408 区域 3 专用列表
const list1408Area3 = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 6500,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 9000,
    tag: ''
}];
export const list1408Area3List = [list1408Area3];
export const expendList1408Area3 = [...list1408Area3];

// 1409 区域 3 专用价格：仅华大壹号为 7999，其他产品沿用默认配置。
const list1409Area3 = listGuoShou.map(item => ({
    ...item,
    label: item.id === 6 ? 7999 : item.label,
}));
export const list1409Area3List = [list1409Area3];
export const expendList1409Area3 = [...list1409Area3];

// 1414 专用价格：基因溯源调整为 3800，其他产品沿用默认配置
const list1414 = list3.map(item => ({
    ...item,
    label: item.id === 5 ? 3800 : item.label,
}));
const list1414Area3 = list1414.map(item => ({
    ...item,
    label: item.id === 6 ? 8999 : item.label,
}));
export const list1414List = [list1414];
export const expendList1414 = [...list1414];
export const list1414Area3List = [list1414Area3];
export const expendList1414Area3 = [...list1414Area3];

// 平顶山（1208）专用列表：保留基因溯源+华大壹号，追加华大壹号PLUS和IPSC时光胶囊
const listPingDingShan = [
    ...listGuoShou,
    {
        id: 11,
        className: 'flex-1',
        name: '华大壹号PLUS',
        label: 12000,
        tag: ''
    },
    {
        id: 13,
        className: 'flex-1',
        name: 'IPSC时光胶囊',
        label: 9999,
        tag: ''
    }
];
export const pingDingShanList = [listPingDingShan];
export const expendPingDingShanList = [...listPingDingShan];

export const zhoukouList = [zhoukou];
export const expendZhoukouList = [...zhoukou];

export const list1244 = [list1244Config];
export const expendList1244 = [...list1244Config];
export const list1245 = [list1245Config];
export const expendList1245 = [...list1245Config];

// 1142 专用列表：保留基因溯源+华大壹号（不包含雾化套装）
const list1142 = [...listGuoShou];
export const list1142List = [list1142];
export const expendList1142 = [...list1142];

// 1283 专用列表：只展示基因溯源
const list1283 = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}];
export const list1283List = [list1283];
export const expendList1283 = [...list1283];

// 1126（株洲科养）专用列表：基于 listGuoShouZhuZhou 去掉「外泌体雾化6支」
const list1126 = listGuoShouZhuZhou.filter(item => item.name !== '外泌体雾化6支');
export const list1126List = [list1126];
export const expendList1126 = [...list1126];

export const taiZhouList = [listTaiZhou];
export const expendTaiZhouList = [...listTaiZhou];

export const yangZhouList = [listYangZhou];
export const expendYangZhouList = [...listYangZhou];

export const tianJinList = [listTianJin];
export const expendTianJinList = [...listTianJin];
export const tianJinArea1List = [listTianJinArea1];
export const expendTianJinArea1List = [...listTianJinArea1];



export const suZhouList = [listSuZhou];
export const expendSuZhouList = [...listSuZhou];

export const listSuZhouShenZhenList = [listSuZhouShenZhen];
export const expendSuZhouShenZhenList = [...listSuZhouShenZhen];

export const suZhouWuZhongList = [listSuZhouWuZhong];
export const expendSuZhouWuZhongList = [...listSuZhouWuZhong];

export const org987List = [listOrg987];
export const expendOrg987List = [...listOrg987];

export const org1284List = [listOrg1284];
export const expendOrg1284List = [...listOrg1284];
export const org1284Area3List = [listOrg1284Area3];
export const expendOrg1284Area3List = [...listOrg1284Area3];

export const changZhouList = [listChangZhou];
export const expendChangZhouList = [...listChangZhou];



export const list2 = [list1];
export const expendList2= [...list1];
export const listzhengzhou = [zhengzhou];
export const expendListzhengzhou= [...zhengzhou];
export const listshaoyang = [shaoyang];
export const expendListshaoyang= [...shaoyang];
export const keyNo1113List = [...list1, {
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 8000,
    tag: ''
}];

export const item = JSON.parse(JSON.stringify({
    personName: "", // 客户姓名
    personIdCard: "", // 客户身份证号
    personPhone: "", // 客户手机号
    checkStartTime: "", // 开始时间
    productList: [], // 产品列表
    sum: 0, // 总计
  }));
